import React, { Component } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
    fetchOrdenesParaNuevaLiquidacion,
    fetchNovedadesParaNuevaLiquidacion
} from '../../../../actions/LiquidacionesActions';
import { getLiquidacionesListaSellers, postNuevaLiquidacionFinal } from '../../../../api/axios.js';
import LiquidacionNewOrdenes from './LiquidacionNewOrdenes';
import LiquidacionNewNovedades from './LiquidacionNewNovedades';
import '../../shared/liquidacionesModule.css';
import LiquidacionesPageHeader from '../../shared/LiquidacionesPageHeader';
import LiquidacionesFilterCard from '../../shared/LiquidacionesFilterCard';
import { LiquidacionesBtnBuscar, LiquidacionesBtnGuardar } from '../../shared/LiquidacionesButtons';
import { LIQUIDACIONES_ROUTES } from '../../shared/liquidacionesRoutes';
import Select from 'react-select';
import BigSpinner from '../../../General/BigSpinner';
import MiniSpinner from '../../../General/MiniSpinner';
import { toast } from '../../../../utilities/appToast';
import { toastApiErrors } from "../../../../utilities/apiErrors";
import { DropDownArrow, customStyleFilterWrap, filterSelectMenuPortalProps } from "../../../../template/CustomStyle";
import { filtroMedioMes } from '../../../../utilities/fechasFiltro';
import '../../../General/AdminListCard.css';

// Wrapper para usar hooks en class component
function LiquidacionNewWrapper(props) {
  const navigate = useNavigate();
  return <LiquidacionNew {...props} navigate={navigate} />;
}
const fechaFiltro = filtroMedioMes();

class LiquidacionNew extends Component {
    constructor(props) {
        super(props);
        this.idOrdenesSeleccionadas = React.createRef();
        this.idNovedadesSeleccionadas = React.createRef();
        this.state = {
            hideSpinner: true,
            hiddenFirstSearch: true,
            lista_sellers_liquidaciones: [],
            isLoadingSellersOptions: false,
            lista_liquidaciones_busqueda: [],
            comboLiquidacionSeller: { label: "", value: "" },
            comboLiquidacionEstado: { label: "", value: "" },
            fechaDesdeSesenta: "",
            creating: false,
            request: {
                fechaDesde: fechaFiltro.desde,
                fechaHasta: fechaFiltro.hasta,
                idSeller: "",
                idEstado: 2
            }
        }
    };

    componentDidMount() {

        this.setState({ hiddenFirstSearch: true });
        localStorage.setItem("CrearLiquidacionSeller", "");

        let fechasesenta = new Date();
        fechasesenta.setDate(fechasesenta.getDate() - 360);
        let fechafechasesentafinal = fechasesenta.toISOString().slice(0, 10);
        this.setState({ fechaDesdesesenta: fechafechasesentafinal });
    }

    myChangeHandler = async (e) => {
        const { name, value } = e.target;
        this.setState({ request: { ...this.state.request, [name]: value } });
    }

    onSubmitBusqueda = (event) => {

        event.preventDefault();
        let request = { ...this.state.request }

        if (request.fechaDesde == "") {
            toast.warn("Debe seleccionar una fecha inicial");
            return;
        }

        if (request.fechaHasta == "") {
            toast.warn("Debe seleccionar una fecha final");
            return;
        }

        if (localStorage.getItem('CrearLiquidacionSeller') == "" || localStorage.getItem('CrearLiquidacionSeller') == undefined) {
            toast.warn("Debe seleccionar un Seller");
            return;
        }

        request.idSeller = parseInt(localStorage.getItem('CrearLiquidacionSeller'));
        this.setState({ hiddenFirstSearch: false });

        this.props.fetchOrdenesParaNuevaLiquidacion(request);

        request.idEstado = 3;
        // Paginación por defecto: primeras 100 novedades
        request.NumeroPagina = 1;
        request.TamanoPagina = 100;
        this.props.fetchNovedadesParaNuevaLiquidacion(request);
    }

    crearLiquidacion = async (event) => {

        event.preventDefault();
        this.setState({ hideSpinner: false });
        let idOrdenes = this.idOrdenesSeleccionadas
            .current
            .state
            .ordenes
            .filter(x => x.checked === true)
            .map(x => x.idOrden)
            ;

        if (idOrdenes.length === 0) {
            toast.warn("Selecione alguna orden. No puede crear una liquidacion sin orden");
            return;
        }

        let idNovedades = this.idNovedadesSeleccionadas
            .current
            .state
            .novedades
            .filter(x => x.checked === true)
            .map(x => x.idNovedad)
            ;

        let data = {
            ordenesSeleccionadas: idOrdenes,
            novedadesSeleccionadas: idNovedades,
            Seller: parseInt(localStorage.getItem('CrearLiquidacionSeller')),
            idEstado: 3
        }

        let post = postNuevaLiquidacionFinal(data);

        post.then(res => {
            toast.success("La liquidacion fue creada con éxito.");
            this.goToLiquidaciones();
        }).catch(err => {
            if (!toastApiErrors(err, toast, { fallbackMessage: "No pudimos crear la liquidación", level: "warn" })) {
                toast.error("No pudimos crear la liquidación");
            }
            this.goToLiquidaciones();
        });
    }

    crearLiquidacionBorrador = async (event) => {

        event.preventDefault();
        this.setState({creating: true})
        let idOrdenes = this.idOrdenesSeleccionadas
            .current
            .state
            .ordenes
            .filter(x => x.checked === true)
            .map(x => x.idOrden)
            ;

        if (idOrdenes.length === 0) {
            toast.warn("Selecione alguna orden. No puede crear una liquidacion sin orden");
            return;
        }

        let idNovedades = this.idNovedadesSeleccionadas
            .current
            .state
            .novedades
            .filter(x => x.checked === true)
            .map(x => x.idNovedad)
            ;

        let data = {
            ordenesSeleccionadas: idOrdenes,
            novedadesSeleccionadas: idNovedades,
            Seller: parseInt(localStorage.getItem('CrearLiquidacionSeller')),
            idEstado: 2
        }

        let post = postNuevaLiquidacionFinal(data);

        post.then(res => {
            toast.success("El borrador de liquidacion fue creado con éxito.");
            this.setState({ creating: false })
            this.goToLiquidaciones();
        }).catch(err => {
            if (!toastApiErrors(err, toast, { fallbackMessage: "No pudimos crear el borrador de liquidación" })) {
                toast.error("No pudimos crear el borrador de liquidación");
            }
            this.goToLiquidaciones();
        });
    }

    selectSearchHandlerLiquidacionesEstado = (options) => {
        let valor = { label: options.label, value: options.value.toString() };
        this.setState({ comboLiquidacionEstado: valor });
        localStorage.setItem('ListLiquidacionesEstado', options.value);
    }

    selectSearchHandlerLiquidacionesSeller = (options) => {
        let valor = { label: options.label, value: options.value.toString() };
        this.setState({ comboLiquidacionSeller: valor });
        localStorage.setItem('CrearLiquidacionSeller', options.value);
    }

    selectSearchHandlerLiquidacionesEstado = (options) => {
        let valor = { label: options.label, value: options.value.toString() };
        this.setState({ comboLiquidacionEstado: valor });
        localStorage.setItem('GestionDeLiquidacionEstado', options.value);
    }

    mapSellers = async () => {
        if (this.state.isLoadingSellersOptions) return;
        if (Array.isArray(this.state.lista_sellers_liquidaciones) && this.state.lista_sellers_liquidaciones.length > 0) return;

        this.setState({ isLoadingSellersOptions: true });
        try {
            const res = await getLiquidacionesListaSellers();
            const listaTipo = Array.isArray(res?.listaSellersLiquidaciones)
                ? res.listaSellersLiquidaciones.map((tipo) => ({
                    label: tipo.razonSocial,
                    value: tipo.codigo.toString()
                }))
                : [];

            this.setState({ lista_sellers_liquidaciones: listaTipo });
        } finally {
            this.setState({ isLoadingSellersOptions: false });
        }
    }

    goToLiquidaciones = () => {
        this.props.navigate("/Liquidaciones");
    }


    render() {

        const isLoading = this.state.hiddenFirstSearch ||
            this.props.isLoadingOrdenesLiquidacion ||
            this.props.isLoadingNovedadesLiquidacion
            ;
        const noOptionsMessage = () => 'Sin opciones';
        const loadingOptionsMessage = () => 'Cargando...';
        let ordenes = Array.isArray(this.props.ordenesLiquidacion) ? this.props.ordenesLiquidacion : [];
        let novedades = Array.isArray(this.props.novedadesLiquidacion) ? this.props.novedadesLiquidacion : [];


        return (
            <div className="container gestion-liquidaciones liquidaciones-modulo">

                <LiquidacionesPageHeader
                    title="Crear liquidación"
                    subtitle="Selección de seller, rango de fechas y generación de liquidación."
                    onBack={this.goToLiquidaciones}
                    backLabel="Volver"
                    showBack
                />

                <form className="form-horizontal form-material gestion-liquidaciones-form" onSubmit={this.onSubmitBusqueda}>
                    <LiquidacionesFilterCard
                        actions={(
                            <LiquidacionesBtnBuscar type="submit">Buscar</LiquidacionesBtnBuscar>
                        )}
                    >
                            <div className="row g-3 align-items-end">

                                    <div className="col-12 col-md-3">
                                        <p className="gestion-liquidaciones-filtro-label mb-0">Desde</p>
                                        <input
                                            type="date"
                                            name="fechaDesde"
                                            className="form-control"
                                            onChange={this.myChangeHandler}
                                            max={fechaFiltro.hasta}
                                            min={this.state.fechaDesdesesenta}
                                            value={this.state.request.fechaDesde}
                                        />
                                    </div>

                                    <div className="col-12 col-md-3">
                                        <p className="gestion-liquidaciones-filtro-label mb-0">Hasta</p>
                                        <input
                                            type="date"
                                            name="fechaHasta"
                                            className="form-control"
                                            onChange={this.myChangeHandler}
                                            max={fechaFiltro.hasta}
                                            min={this.state.fechaDesdesesenta}
                                            value={this.state.request.fechaHasta}
                                        />
                                    </div>

                                    <div className="col-12 col-md-3">
                                        <p className="gestion-liquidaciones-filtro-label mb-0">Seller</p>
                                        <Select
                                            id="CrearLiquidacionSeller"
                                            name="CrearLiquidacionSeller"
                                            value={this.state.comboLiquidacionSeller}
                                            options={this.state.lista_sellers_liquidaciones}
                                            onChange={this.selectSearchHandlerLiquidacionesSeller}
                                            onMenuOpen={this.mapSellers}
                                            styles={customStyleFilterWrap}
                                            {...filterSelectMenuPortalProps}
                                            isLoading={this.state.isLoadingSellersOptions}
                                            loadingMessage={loadingOptionsMessage}
                                            noOptionsMessage={noOptionsMessage}
                                            components={{ DropdownIndicator: () => DropDownArrow, LoadingIndicator: () => null }}
                                        />
                                    </div>

                            </div>
                    </LiquidacionesFilterCard>
                </form>

                <div hidden={!this.props.isLoadingOrdenesLiquidacion && !this.props.isLoadingNovedadesLiquidacion}>
                    <BigSpinner message="Cargando ordenes y novedades para liquidar..." />
                </div>

                <div hidden={isLoading}>

                    <div className="p-10">
                        <LiquidacionNewOrdenes
                            ordenes={ordenes}
                            ref={this.idOrdenesSeleccionadas}
                        />
                    </div>

                    <div className="p-10">
                        <LiquidacionNewNovedades
                            novedades={novedades}
                            ref={this.idNovedadesSeleccionadas}
                        />
                    </div>

                </div>

                <div
                    className="row justify-content-center align-items-center"
                    hidden={isLoading || ordenes.length === 0}
                >
                    <div className="col-auto">
                        <form
                            className="form-horizontal form-material"
                            onSubmit={this.crearLiquidacionBorrador}
                        >
                            <LiquidacionesBtnGuardar
                                hidden={this.state.creating}
                                type="submit"
                                disabled={this.props.isLoadingOrdenesLiquidacion && this.props.isLoadingNovedadesLiquidacion}
                            >
                                Crear borrador
                            </LiquidacionesBtnGuardar>
                        </form>
                    </div>
                    <div className="d-flex justify-content-center">
                        <div hidden={!this.state.creating}>
                            <MiniSpinner />
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}


const mapStateToProps = state => ({
    tipoUsuario: state.general.tipoUsuario,
    lista_sellers_liquidaciones: state.sellers.lista_sellers_liquidaciones,
    isLoadingOrdenesLiquidacion: state.liquidaciones.isLoadingOrdenesLiquidacion,
    isLoadingNovedadesLiquidacion: state.liquidaciones.isLoadingNovedadesLiquidacion,
    ordenesLiquidacion: state.liquidaciones.ordenesLiquidacion,
    novedadesLiquidacion: state.liquidaciones.novedadesLiquidacion
});

export default connect(mapStateToProps, {
    fetchOrdenesParaNuevaLiquidacion,
    fetchNovedadesParaNuevaLiquidacion
}) (LiquidacionNewWrapper);